<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            ref="prepaidOrderTableRef"
            :table="table"
            @expandRow="expandRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @selectRow="selectRow"
            @selectAllRow="selectAllRow"
            @sorterChange="sorterChange"
            @cellClick="cellClick"
        >
            <!-- 表头操作 -->
            <!-- <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.order.createOrder'" @click="handle('createOrder')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('order.create') }}
                </a-button>
            </template> -->

            <!-- 自定义字段 -->
            <template v-slot:columns="{ props }">
                <!-- 父表格自定义字段 -->
                <div v-if="props.column.key == 'order_name'">
                    <span style="padding-left:0;color:#165dff;cursor:pointer;" @click="handle('goInvoiceList', props.record)">{{props.record.order_name}}</span>
                </div>
                <div v-if="props.column.key == 'order_status'" style="font-size:12px;">
                    <a-badge :color="getOrderStatus('badgeOrderStatus', props.record.order_status)" :text="props.record.order_status" />
                </div>
                <div v-if="props.column.key == 'validity_status'" style="font-size:12px;">
                    <a-tag v-if="props.record.validity_status != '-'" :color="props.record.validity_status_val == 1? 'green' : 'red'">{{ props.record.validity_status }}</a-tag>
                    <span v-else>{{props.record.validity_status}}</span>
                </div>
                <div v-if="props.column.key == 'amount'">
                    <div class="amountBlock" :class="{'amountBlock2':locale == 'zh'}">   
                        <p>
                        <span> {{ $t('order.orderAmount') }}：</span>
                        {{ props.record.order_amount }}
                        </p>
                        <p>
                            <span> {{ $t('order.InvoiceAmount') }}：</span>
                            {{ props.record.pay_amount }}
                        </p>
                        <div v-if="props.record.showAmount">
                            <p>
                                <span>{{ $t('order.orderDiscount') }}：</span>
                                {{ props.record.order_discount }}
                            </p>
                            <p>
                                <span>{{ $t('order.cargoFreight') }}：</span>
                                {{ props.record.cargo_freight }}
                            </p>
                            <p>
                                <span>{{ $t('order.orderTax') }}：</span>
                                {{ props.record.order_tax }}
                            </p>
                            <p>
                                <span>{{ $t('order.taxRate') }}：</span>
                                {{ props.record.tax_rate }}
                            </p>    
                        </div>
                        <div class="arrowTop" :class="{'arrowBottom': props.record.showAmount}">
                            <p style="color: #4393fa;cursor: pointer;" v-if="!props.record.showAmount" @click="props.record.showAmount = !props.record.showAmount">
                                <icon-down-circle size="14"/>
                            </p>
                            <p style="color: #4393fa;cursor: pointer;" v-else @click="props.record.showAmount = !props.record.showAmount">
                                <icon-up-circle size="14" />
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="props.column.key == 'customer_info'">
                        <div style="font-size:12px;color: #666;">{{ $t('base.email')}}：{{ props.record.customer_email }}</div>
                        <a-popover position="top" trigger="click" @popup-visible-change="(val)=>popupVisibleChange(val,props.record)">
                            <a-button type="text" style="padding:0;text-wrap: wrap; text-align: left;">
                                <span style="font-size:12px;color:#666">{{ $t('base.name') }}：</span>
                                {{ props.record.customer_name }}
                            </a-button>
                            <template #content>
                                <div style="display:inline-block;vertical-align: top;">
                                    <div style="font-weight:bold;text-align:center">{{ $t('order.customerInfo') }}</div>
                                    <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" style="padding:0 15px;">
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName') }}：</span> {{ customerInfo.name }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span> {{ customerInfo.name2 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo.phone }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo.zip }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo.city }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo.address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo.address22 }}</div>
                                        <div v-if="props.record.customer_id == props.record.customer_invoice_id"><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo.billing_address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCountry') }}：</span> {{ customerInfo.country }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                                    </a-spin>
                                </div>
                                <div v-if="props.record.customer_id != props.record.customer_invoice_id" style="display:inline-block;vertical-align: top;">
                                    <div style="font-weight:bold;text-align:center;">{{ $t('order.invoiceInfo') }}</div>
                                    <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" style="padding:0 15px;border-left:1px solid #eee;">
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName') }}：</span> {{ customerInfo2.name }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span> {{ customerInfo2.name2 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo2.phone }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo2.zip }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo2.city }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo2.address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo2.address22 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo2.billing_address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCountry') }}：</span> {{ customerInfo.country }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                                    </a-spin>
                                </div>
                                <!-- <div class="edit_icon" style="display:inline-block;vertical-align: top;">
                                    <icon-edit :size="18" @click="editCustomer(customerInfo.customer_entity_id)"/>
                                </div> -->
                            </template>
                        </a-popover>
                </div>
                <div v-if="props.record.remark != '915' && props.column.key == 'instruction' && userInfo.role != '8'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.instructionIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    <a-input v-if="!props.record.instructionIsText" :style="{width:'180px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.instructionIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.instructionIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
                <div v-if="props.record.remark == '915' && props.column.key == 'instruction'">-</div>
                <div v-if="props.column.key == 'order_channel_type'" style="font-size:12px;">
                    <a-tag :color="getOrderStatus('tagCustomerType', props.record.order_channel_type)">{{ props.record.order_channel_type }}</a-tag>
                </div>


                <!-- 子表格自定义字段 -->
                <!-- <div v-if="props.column.key == 'sku'">
                    <span style="padding-left:0;color:#165dff;cursor:pointer;" @click="handle('showLineDetail', props.record)">{{props.record.sku}}</span>
                </div> -->
                <!-- <div v-if="props.column.key == 'frame_number'">
                    <div v-if="props.record.frame_number.length > 0">
                        <div v-for="(item,index) in props.record.frame_number" :key="index" style="font-size:12px;" :style="{'color':item.vehicle_status == 1?'red' : '#333'}">{{ item.frame_number }}</div>
                    </div>
                    <div v-else>-</div>
                </div> -->
                <div v-if="props.column.key == 'model_model_year'">
                    <div v-if="props.record.model == '-' && props.record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ props.record.model }}，{{props.record.model_year}}</div>
                </div>
                <div v-if="props.column.key == 'qty'">
                    <div style="display:flex;font-size:12px" v-if="props.record.quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.ship_quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineShipQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.ship_quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.produce_quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineProductQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.produce_quantity }}</span>
                    </div>
                </div>
                <div v-if="props.column.key == 'line_amount'">
                    <div style="display:flex;font-size:12px" v-if="props.record.amount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.linePrice') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.amount }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.pre_amount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.lineDepositAmount') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.pre_amount }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.tax_rate != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.taxRate') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.tax_rate }}</span>
                    </div>
                </div>
            </template>

            <!-- 父表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-button 
                    v-permission="'setting.prepaidOrder.downloadInvoice'" 
                    type="primary" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.validity_status_val == 2"
                    @click="handle('downloadInvoice',props.record)"
                >{{ $t('order.downloadInvoice') }}</a-button>
                <a-button 
                    v-permission="'setting.prepaidOrder.deliver'" 
                    type="primary" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.delivery_number != '-' || props.record.validity_status_val == 2 || props.record.order_status_val != 1"
                    @click="handle('deliver',props.record)"
                >{{ $t('order.deliver') }}</a-button>
                <a-button 
                    v-permission="'setting.prepaidOrder.unbind'" 
                    type="primary" status="warning" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.delivery_number == '-'"
                    @click="handle('unbind',props.record)"
                >{{ $t('prepaidOrder.unbind') }}</a-button>
                <a-button 
                    v-permission="'setting.prepaidOrder.invalidate'" 
                    type="primary" status="danger" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.validity_status_val == 2 || props.record.order_status_val == 1"
                    @click="handle('invalidate',props.record)"
                >{{ $t('prepaidOrder.invalidate') }}</a-button>
            </template>
        </Table>


        <!-- 申请发货，创建出库单 -->
        <a-modal
            v-model:visible="deliverVisible" 
            width="85%"
            :title="$t('order.deliver')"
            draggable
            :onBeforeOk="onDeliverBeforeOk"
        >
            <Deliver ref="deliverRef" v-if="deliverVisible" :row="rowData"></Deliver>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { PrepaidOrderApi } from '@/api/PrepaidOrderApi.js';
    import { OrderApi } from '@/api/OrderApi.js';  
    import { InvoiceApi } from '@/api/InvoiceApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import { useRouter } from 'vue-router';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Deliver from './Deliver.vue';
    import { PrepaidOrderQuery } from './queryConfig/PrepaidOrderQuery.js';
    
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';

    const router = useRouter()
    const localeStore = useLocale()
    const { t } = useI18n()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const locale = ref(localStorage.getItem('locale'))

    const deliverVisible = ref(false)
    const detailVisible = ref(false)
    const orderSource = ref({})
    const prepaidOrderTableRef  = ref(null)
    const showForm = ref(false)
    const queryForm = reactive(PrepaidOrderQuery)
    const customerInfo = ref({})
    const customerInfo2 = ref({})
    const customerInfo_loading = ref(false)
    const rowData = ref(null)
    const deliverRef = ref(null)
    // 父表格
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '订单名称',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'100',
                align:'left',
                fixed:'left',
                slotName:'slot',
            },
            {
                // title: 'mes出库单号',
                title:t('stock.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'220',
                align:'left',
            },
            {
                // title: '发票号',
                title:t('invoice.invoiceNo'),
                dataIndex: 'invoice_no',
                key:'invoice_no',
                width:'120',
                align:'left',
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                width:'150',
                align:'left',
            },
            {
                // title: 'ERP编号',
                title:t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'150',
                align:'left',
            },
            {
                // title: '订单状态',
                title:t('order.orderStatus'),
                dataIndex: 'order_status',
                key:'order_status',
                width:'160',
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '是否有效',
                title:t('prepaidOrder.validityStatus'),
                dataIndex: 'validity_status',
                key:'validity_status',
                width:'150',
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '备注',
                title:t('order.instruction'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'270',
                slotName:'slot',
                align:'left',
            },
            {
                // title: '金额',
                title:t('order.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'240',
                slotName:'slot',
                align:'left',
            },
            {
                // title: '发货方式',
                title:t('order.deliveryType'),
                dataIndex: 'delivery_type',
                key:'delivery_type',
                width:'130',
                align:'left',
            },
            {
                // title: '订单时间',
                title:t('order.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'130',
                align:'left',
                ellipsis:true,
                tooltip:true,
                sortable: {
                    sortDirections: ['ascend', 'descend'],
                },
            },
            {
                // title: '客户信息',
                title:t('order.customerInfo'),
                dataIndex: 'customer_info',
                key:'customer_info',
                width:'300',
                align:'left',
                slotName: 'slot'
            }, 
            {
                // title: '国家',
                title:t('order.country'),
                dataIndex: 'country',
                key:'country',
                width:'130',
                align:'left',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '180',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 580
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 子表格
    const innerColumns = ref([ 
        {
            // title: 'No.',
            title:'#',
            dataIndex: 'serial',
            key: 'product_name',
            width: '60',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '产品名称',
            title:t('order.productName'),
            dataIndex: 'product_name',
            key: 'product_name',
            width: '170',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        // {
        //     // title: '车架号',
        //     title:t('order.frameNumber'),
        //     dataIndex: 'frame_number',
        //     key: 'frame_number',
        //     width: '160',
        //     align: 'center',
        //     slotName:'slot'
        // },
        {
            // title: 'SKU',
            title:t('order.sku'),
            dataIndex: 'sku',
            key: 'sku',
            width: '200',
            align: 'center',
            ellipsis:true,
            tooltip:true,
            // slotName:'slot',
        },
        {
            // title: '物料编码',
            title:t('order.inventoryCode'),
            dataIndex: 'inventory_code',
            key: 'inventory_code',
            width: '140',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '车型',
            title:t('order.modelModelYear'),
            dataIndex: 'model_model_year',
            key: 'model_model_year',
            width: '200',
            align: 'center',
            ellipsis:true,
            tooltip:true,
            slotName:'slot',
        },
        {
            // title: '数量',
            title:t('order.qty'),
            dataIndex: 'qty',
            key: 'qty',
            width: '120',
            align: 'center',
            slotName:'slot',
        },
        {
            // title: '行金额',
            title:t('order.lineAmount'),
            dataIndex: 'line_amount',
            key: 'line_amount',
            width: '170',
            align: 'center',
            slotName:'slot',
        },
        {
            // title: '预计发货时间',
            title:t('order.handleTimestamp'),
            dataIndex: 'handle_timestamp_val',
            key: 'handle_timestamp_val',
            width: '130',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        }, 
    ])
    const innerConfigs = ref({
        scroll: {
            x: 1000,
            y: 200,
        },
        stripe: false,
        bordered: false,
        size: 'large',
        loading: false,
        pagination: false,
    })

    const orderStatus = ref({  // 订单状态
        '-1':t('order.finalPayment'), // 尾款单
        '0':t('order.partialPay'), // 部分付款
        '1':t('order.pay'), // 支付
        '2':t('order.refund'), // 退款
        '4':t('order.partialRefund'), // 部分退款
        '6':t('order.canceled'), // 取消
        '7':t('order.obligation') // 待付款
    })

    const outboundStatus = ref({ // 出库状态
        0:t('order.initial'),
        1:t('order.unOutbound'),
        2:t('order.outbound'),
        3:t('stock.cancelOutbound2'),
    })

    const getOrderStatus = (type, data)=>{
        
        // 订单状态
        const badgeOrderStatus = [
            {
                type:t('order.finalPayment'), // 尾款单
                color:'arcoblue',
            },
            {
                type:t('order.partialPay'), // 部分支付
                color:'#ff4500',
            },
            {
                type:t('order.pay'), // 支付
                color:'green',
            },
            {
                type:t('order.refund'), // 退款
                color:'pink',
            },
            {
                type:t('order.returnsAndRefund'), // 退货退款
                color:'orange',
            },
            {
                type:t('order.partialRefund'), // 部分退款
                color:'gold',
            },
            {
                type:t('order.partialReturnsAndRefund'), // 部分退货退款
                color:'pinkpurple',
            },
            {
                type:t('order.canceled'), // 已取消
                color:'gray',
            },
            {
                type:t('order.obligation'), // 待付款
                color:'#ad0606',
            },
        ]

        // 发货状态
        const badgeCourierStatus = [
            {
                type:t('order.unship'), // 未发货
                color:'magenta',
            },
            {
                type:t('order.plan'), // 计划发货
                color:'blue',
            },
            {
                type:t('order.partialShip'), // 部分发货
                color:'orange',
            },
            {
                type:t('order.shiped'), // 已发货
                color:'lime',
            },
            {
                type:t('order.signedFor'), // 已签收
                color:'green',
            },
            {
                type:t('order.canceled'), // 已关闭
                color:'#86909c',
            },
            {
                type:t('order.partialReturn'), // 部分退货
                color:'#ea7ccc',
            },
            {
                type:t('order.partialExchange'), // 部分换货
                color:'#afb2f5',
            },
            {
                type:t('order.return'), // 退回
                color:'#f71ebb',
            },
            {
                type:t('order.exchange'), // 更换
                color:'#6e74e0',
            },
            {
                type:'-',
                color:'gray',
            },
        ]

        const outboundStatus = [
            {
                type:t('order.initial'), // 初始
                color:'#ccc',
            },
            {
                type:t('order.unOutbound'), // 未出库
                color:'blue',
            },
            {
                type:t('order.outbound'), // 已出库
                color:'green',
            },
            {
                type:t('stock.cancelOutbound2'), // 取消出库
                color:'orange',
            },
        ]

        const tagCustomerType = [
            { 
                type:t('order.user'), // 用户
                color:'blue',
            },
            {
                type:t('order.dealer'), // 经销商
                color:'green',
            },
            {
                type:t('order.ECommerceVendor'), // E-Commerce Vendor
                color:'yellow',
            },
            {
                type:t('order.notForSale'), // 非销售
                color:'orange',
            },
        ]

        const typeObj = {
            'badgeOrderStatus':badgeOrderStatus,
            'badgeCourierStatus':badgeCourierStatus,
            'tagCustomerType':tagCustomerType,
            'outboundStatus':outboundStatus,
        }
        let item = typeObj[type].find(i=> i.type == data)
        return item && item.color
    }

    const popupVisibleChange = (val,row)=>{
        if(val){
            if(row.customer_id == row.customer_invoice_id){
                getCustomer(row.customer_id)
            }else{
                getCustomer(row.customer_id)
                getCustomerInvoice(row.customer_invoice_id)
            }
        } 
    } 

    // 单击单元格
    const cellClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'instruction'){
            row.instructionIsText = false
        }
    }

    const handlePickerDateChange = (val,item)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData.begin_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
        queryForm.formData.end_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        getPrepaidOrderList()
    }
    
    const handle = (type, row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                queryForm.formData.begin_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`)
                queryForm.formData.end_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`) 
                getPrepaidOrderList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                table.value.configs.pagination.current = 1
                getPrepaidOrderList()
                break;
            case 'unbind':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content:t('prepaidOrder.unbindTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        unbindOutboundOrder(row)
                    },
                })
                break;
            case 'invalidate':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content:t('prepaidOrder.invalidateTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        changeStatusToInvalidate(row)
                    },
                })
                break;
            case 'deliver':
                deliverVisible.value = true
                rowData.value = row
                break;
            case 'downloadInvoice':
                downloadInvoice(row)
                break;
            case 'goInvoiceList':
                router.push({path:'/OrderList/InvoiceList', state:{order_name:row.order_name,fromPage:'PrepaidOrderList'}})
                break;
        }
    }

    // 展开搜索栏
    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 列表查询-select
    const handleSelectChange = ( val, opt, key )=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'customer_id'){
            if(!val){
                queryForm.formData.customer_name = ''
            }else{
                let item = queryForm.formField.find(i=> i.key == 'customer_id')
                let opt = item.options.find(i=> i.value == val)
                queryForm.formData.customer_name = opt.label
            }
        }else{
            queryForm.formData[key] = val
        }
        table.value.configs.pagination.current = 1
        getPrepaidOrderList()
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getPrepaidOrderList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getPrepaidOrderList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getPrepaidOrderList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getPrepaidOrderList()
    }

    // 展开预付款订单行
    const expandRow = (rowKey,record)=>{
        console.log(rowKey,record,'rowKey,record')
        prepaidOrderTableRef.value.expandedKeys = prepaidOrderTableRef.value.expandedKeys.length !== 0? [record.id] : []
        prepaidOrderTableRef.value.selectedKeys = []
        // orderRowData.value = record
        table.value.datas.forEach(item=>{
            if(item.selected) item.selected = []
        })
        getPrepaidOrderLine(record.id, record)
    }

    const formatMoney = (item,key, payCurrency)=>{
        return item[key] == undefined? '-' : payCurrency == 'EUR'? '€ ' + Number(item[key]).toFixed(2) : Number(item[key]).toFixed(2)
    }

    // 获取预付款订单列表
    const getPrepaidOrderList = async()=>{
        let param = {
            ...queryForm.formData,
            delivery_number: queryForm.formData.delivery_number.trim(),
            order_name:queryForm.formData.order_name.trim(),
        }

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await PrepaidOrderApi.getInstance().getPrepaidOrderList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No:index + 1,
                    order_status_val: item.order_status,
                    source_val: item.source,
                    order_status: orderStatus.value[`${item.order_status}`],
                    customer_type_val: item.customer_type,
                    customer_type: item.customer_type == 0? t('order.user') : item.customer_type == 1? t('order.dealer') : item.customer_type == 2? t('order.ECommerceVendor') : t('order.notForSale'),
                    order_channel_type_val: item.order_channel_type,
                    order_channel_type: item.order_channel_type == 0? t('order.user') : item.order_channel_type == 1? t('order.dealer') : item.customer_type == 2? t('order.ECommerceVendor') : t('order.notForSale'),
                    order_type_val: item.order_type,
                    order_type: item.order_type == undefined? '-' : item.order_type == 0? t('order.sale') : t('order.unSale'),
                    source: orderSource.value[item.source],
                    order_amount_val: item.order_amount,
                    pay_amount_val: item.pay_amount,
                    pay_with_days_discount_val:item.pay_with_days_discount == undefined? 0 : item.pay_with_days_discount,
                    order_amount: formatMoney(item,'order_amount','EUR'),
                    order_discount_val: item.order_discount == ''? '-' : item.order_discount,
                    order_discount:  item.order_discount == ''? '-' : formatMoney(item,'order_discount','EUR'), 
                    cargo_freight: item.cargo_freight == ''? '-' : formatMoney(item,'cargo_freight','EUR'), 
                    order_tax_val: item.order_tax,
                    order_tax: item.order_tax == ''? '-' : formatMoney(item,'order_tax','EUR'), 
                    tax_rate_val: item.tax_rate == undefined? '-' : item.tax_rate.toFixed(2),
                    tax_rate: item.tax_rate == undefined? '-' : item.tax_rate * 100 + '%',
                    pay_amount: formatMoney(item,'pay_amount','EUR'),
                    erp_no: !item.erp_no? '-' : item.erp_no,
                    order_timestamp_val:item.order_timestamp,
                    order_timestamp: timestampToDate(item.order_timestamp * 1000).split(' ')[0],
                    create_date: !item.create_timestamp? '-' :  timestampToDate(item.create_timestamp * 1000).split(' ')[0], 
                    instructionIsText:true,
                    create_user: !item.create_user? '-' : item.create_user,
                    user_note: !item.user_note? '-' : item.user_note,
                    showAmount:false,
                    delivery_type: item.delivery_type? item.delivery_type : '-',
                    sendBtnText: !item.invoice_send_number? t('order.sendInvoice2') : t('order.reSend'),
                    sendConfirmationBtnText: t('order.sendConfirmation'),
                    delivery_number: !item.delivery_number? '-' : item.delivery_number,
                    validity_status_val: item.validity_status,
                    validity_status: !item.validity_status? '-' : item.validity_status == 1? t('prepaidOrder.valid') :t('prepaidOrder.invalid'),
                    invoice_no: !item.invoice_no? '-' : item.invoice_no,
                    child:{
                        innerDatas:[],
                        innerColumns:innerColumns.value,
                        innerConfigs:innerConfigs.value,
                    },
                })
            })

            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false

            prepaidOrderTableRef.value.expandedKeys = []
        }else{
            Message.error(res.msg)
        }
    }

    //获取预付款订单行
    const getPrepaidOrderLine = async(id,row,type)=>{
        let param = {
            prepaid_order_id: id,
        }
        let item = table.value.datas.find(i=> i.id == id)
        item.child.innerConfigs.loading = true

        let res = await PrepaidOrderApi.getInstance().getPrepaidOrderLine(param)
        if(res.code == 0){
            res.data.forEach((i,index)=>{
                i.serial = index + 1
                i.order_id = row.id
                i.erp_no = row.erp_no
                i.customer_name = row.customer_name
                i.country = row.country
                i.order_name = row.order_name
                i.source = row.source
                i.frame_number = i.frame_number,
                i.order_line_no = i.order_line_no == undefined? '-' : i.order_line_no
                i.erp_line_no = !i.erp_line_no? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code
                i.inventory = i.inventory == undefined? '-' :  i.inventory 
                i.model = i.product_map == undefined? '-' : i.product_map.model == undefined? '-' : i.product_map.model
                i.model_year = i.product_map == undefined ? '-' : i.product_map.model_year == undefined? '-' : i.product_map.model_year
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.ship_quantity = i.ship_quantity == undefined? '-' :i.ship_quantity
                i.scheduling_quantity = i.scheduling_quantity == undefined? '-' : i.scheduling_quantity,
                i.back_number = i.back_number == undefined? '-' : i.back_number,
                i.produce_quantity = i.produce_quantity == undefined? '-' : i.produce_quantity,
                i.back_status = i.back_status == undefined? '-' : i.back_status == 1? t('order.returning') : i.back_status == 2? t('order.swaping') :  i.back_status == 3? t('order.returned') : t('order.swaped'),
                i.unit_code = i.product_map == undefined? '-' : i.product_map.unit_code
                i.pay_currency = row.pay_currency
                i.amount_val = i.amount
                i.discount_val = i.discount
                i.pay_amount_val = i.pay_amount
                i.amount = formatMoney(i,'amount','EUR') 
                i.discount = formatMoney(i,'discount','EUR')
                i.pay_amount = formatMoney(i,'pay_amount','EUR')
                i.pre_amount = i.pre_amount == undefined? '-' : formatMoney(i,'pre_amount','EUR'),
                i.handle_timestamp_val = i.handle_timestamp == undefined? '-' : timestampToDate(i.handle_timestamp * 1000).split(' ')[0],
                i.torque = i.torque == undefined? '-' : i.torque
                i.tax_rate = i.tax_rate == undefined? '-' : i.tax_rate * 100 + '%'
            })

            item.child.innerDatas = res.data
            item.child.innerConfigs.loading = false
           
        }else{
            Message.error(res.msg)
        }
    }

    // 下载发票
    const downloadInvoice = async (row)=>{
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().downloadPrepaidInvoice(row.id, {})
        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                getPrepaidOrderList()
                Message.success(t('base.downloadSuccess'))
            },1500) 
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 变更预付款订单为无效
    const changeStatusToInvalidate = async (row)=>{
        let param = {
            status:2
        }
        let res = await PrepaidOrderApi.getInstance().changeStatus(param, row.id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            getPrepaidOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 解绑出库单
    const unbindOutboundOrder = async (row)=>{
        let param = {
            delivery_number:row.delivery_number,
        }
        let res = await PrepaidOrderApi.getInstance().unbindOutboundOrder(param, row.id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            getPrepaidOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 取消保存备注
    const cancelSaveComment = (row)=>{
        row.instructionIsText = true
        getPrepaidOrderList()
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            instruction:row.instruction
        }
        let res = await PrepaidOrderApi.getInstance().editRemark(param, row.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.instructionIsText = true
            getPrepaidOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 确认申请发货 
    const onDeliverBeforeOk = async (row)=>{
        await deliverRef.value.deliver()
        getPrepaidOrderList()
    }

    // 获取用户地址信息
    const getCustomer = async (customer_id)=>{
        customerInfo_loading.value = true
        let res = await OrderApi.getInstance().getCustomer(customer_id)
        if(res.code == 0){
            customerInfo.value = {
                ...res.data,
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    const getCustomerInvoice = async (customer_invoice_id)=>{
        customerInfo_loading.value = true
        let res = await OrderApi.getInstance().getCustomer(customer_invoice_id)
        if(res.code == 0){
            customerInfo2.value = {
                ...res.data,
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let queryFormItem = queryForm.formField.find(i=> i.key == 'source')
            queryFormItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.id){
                    orderSource.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
                }
            })
            res.data.length > 0 && res.data.forEach(i=>{
                queryFormItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
            })
        }else{
            Message.error(res.msg)
        }
    } 

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async ()=>{
        await getOrderSource()
        getPrepaidOrderList()
        getCountry()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
       
    })


</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: -10px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 12px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    font-size: 12px;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-table-cell-fixed-expand{
    margin-bottom:15px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/.childrenTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background-color: #ddd !important;
    }

    .arco-icon-filter{
        color: #fff;
    }
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 120px;
        }
    }
}

.amountBlock2{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 70px;
        }
    }
}

.arrowTop{
    position: absolute;
    top: 10px;
    left: -20px;
}

.arrowBottom{
    top: 60px;
}

.orderName{
    color: #4080ff;
    cursor: pointer;
}

.remark_content{
    display:inline-block;
    width:180px;
    line-height:11px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    cursor: pointer;
}

.remark{
    padding: 3px;
    background: #f5f5f5;
    cursor: pointer;
}

/deep/ .arco-btn-size-mini{
    height: 20px;
    margin: 0 2px;
    padding: 5px 3px;
    font-size: 11px;
}

</style>